export const baseEndpoint = '/v1/opportunities/$id/loan-details';

export const loanDetailsConfigs = {

    //Overview
    update_overview: {
        method: 'PUT',
        endpoint: `${baseEndpoint}/overview`
    },
    get_overview: {
        method: 'GET',
        endpoint: `${baseEndpoint}/overview`,
    },

    //Borrower
    get_borrower: {
        method: 'GET',
        endpoint: `${baseEndpoint}/borrower`,
    },
    update_borrower: {
        method: 'PUT',
        endpoint: `${baseEndpoint}/borrower`,
    },

    //Additional Guarantors
    get_additional_guarantors: {
        method: 'GET',
        endpoint: `${baseEndpoint}/additional-guarantors`,
    },
    update_additional_guarantors: {
        method: 'PUT',
        endpoint: `${baseEndpoint}/additional-guarantors`,
    },

    // Equity Structure
    get_equity_structure: {
        method: 'GET',
        endpoint: `${baseEndpoint}/equity-structure`,
    },
    update_equity_structure: {
        method: 'PUT',
        endpoint: `${baseEndpoint}/equity-structure`,
    },

    // Additional Team Members
    get_additional_team_members: {
        method: 'GET',
        endpoint: `${baseEndpoint}/additional-team-members`,
    },
    update_additional_team_members: {
        method: 'PUT',
        endpoint: `${baseEndpoint}/additional-team-members`,
    }
}